var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"inline-flex list-none",attrs:{"tabindex":null,"aria-disabled":true}},[_c('span',{staticClass:"text-xs text-slate-600 dark:text-slate-100 mt-1 font-medium w-full block text-left rtl:text-right whitespace-nowrap p-2"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }